import React from 'react'

const UploadLoadingScreen = () => {
  return (
    <div className='upload-loading-screen-wrapper'>
      <div class="loading-spinner"></div>
      <div>Uploading your video. This may take a moment...</div>
    </div>
  )
}

export default UploadLoadingScreen
